import {toast} from "react-toastify";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";

const SubmitAdvertisingCampaignData = async (sendData , navigateTo) => {

  if (sendData?.campaignName === "") {
    return toast.error("نام کمپین را وارد کنید")
  }
  if (sendData?.startDate === "") {
    return toast.error("تاریخ شروع را انتخاب کنید")
  }
  if (sendData?.sendData === "") {
    return toast.error("تاریخ پایان را انتخاب کنید")
  }

  let tableData = []
  sendData?.campaignDetail.forEach((c) => {
    if (c.checked) {
      tableData.push(c)
    }
  })

  if (tableData.length === 0) {
    return toast.error("اطلاعات ورودی نا معتبر")
  }
  const Data = {
    request: "campaignSubmit",
    campaignData: {...sendData, campaignDetail: tableData}
  }
  const response = await _axios.post(prefixUrl() + "/discountCampaign/", Data)
  if (response.data.status) {
    toast.success(response.data.message)
    navigateTo(-1)
  } else
    toast.error(response.data.message);
};

export default SubmitAdvertisingCampaignData;